@let fact = item();
@let attribution = source();

<qpx-hero-icon
    class="metadata-icon shrink-0"
    [name]="fact.icon"
    [context]="fact.context"
/>
<dl class="metadata-copy m-0 grid min-w-0 flex-1 content-start gap-0.5">
    <dt
        #sourceRow
        class="metadata-label flex min-w-0 flex-wrap items-center gap-1.5"
    >
        <span
            #sourceLabel
            data-focused-preview-label
            class="cursor-help text-body-md font-semibold text-muted"
        >
            {{ fact.label }}
        </span>
        <button
            #sourceTrigger
            qpxButton="unstyled"
            data-focused-preview-source-trigger
            class="rounded-sm focus-visible:outline-2 focus-visible:outline-offset-2"
            aria-haspopup="dialog"
            [attr.aria-expanded]="popover.isOpen()"
            [attr.aria-label]="`About ${fact.label}: ${attribution.label}`"
            (click)="onClick()"
            (focusout)="onFocusOut($event)"
        >
            @if (attribution.iconOnly) {
                <span
                    class="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-background text-muted"
                    data-building-source-fallback-icon
                    aria-hidden="true"
                    ><ng-icon
                        qpx
                        context="secondary"
                        tone="muted"
                        size="xs"
                        [name]="attribution.icon"
                /></span>
            } @else {
                <qpx-pill
                    size="sm"
                    [icon]="attribution.icon"
                    [label]="attribution.label"
                    [context]="attribution.context.family"
                    [tone]="attribution.context.tone ?? 'default'"
                    [iconOnly]="attribution.iconOnly || compactSource()"
                    [decorative]="true"
                    [darkenIconBackground]="!attribution.iconOnly"
                />
            }
        </button>
        <span
            #expandedSourceMeasure
            aria-hidden="true"
            class="absolute invisible inline-flex pointer-events-none"
        >
            @if (attribution.iconOnly) {
                <span
                    class="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-background text-muted"
                    data-building-source-fallback-icon
                    aria-hidden="true"
                    ><ng-icon
                        qpx
                        context="secondary"
                        tone="muted"
                        size="xs"
                        [name]="attribution.icon"
                /></span>
            } @else {
                <qpx-pill
                    size="sm"
                    [icon]="attribution.icon"
                    [label]="attribution.label"
                    [context]="attribution.context.family"
                    [tone]="attribution.context.tone ?? 'default'"
                    [decorative]="true"
                    [darkenIconBackground]="!attribution.iconOnly"
                />
            }
        </span>
    </dt>
    <dd
        class="min-w-0 m-0 text-body-md leading-normal font-semibold text-foreground"
        [class.text-muted]="fact.unknown"
        [class.line-clamp-2]="fact.definitionKey === 'about'"
    >
        {{ fact.value }}
    </dd>
</dl>
